import { render, staticRenderFns } from "./CourseDashboard.vue?vue&type=template&id=2d905114&scoped=true"
import script from "./CourseDashboard.vue?vue&type=script&lang=ts"
export * from "./CourseDashboard.vue?vue&type=script&lang=ts"
import style0 from "./CourseDashboard.scss?vue&type=style&index=0&id=2d905114&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d905114",
  null
  
)

export default component.exports